<template>
    <b-modal id="modal-viewCertificado" size="lg" hide-footer>
        <template v-slot:modal-title>
          <label>Vista certificado</label>
        </template>
        <b-form-group>
          <img v-bind:src="certificado.urlHeader" style="max-width: 100%">
          <span v-html="certificado.contenido"></span>
          <img v-bind:src="certificado.urlFooter" style="max-width: 100%">
        </b-form-group>
    </b-modal>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  data(){
    return{
      certificado:{
        urlHeader:'',
        contenido:'',
        urlFooter:''
      }
    }
  },
  computed:{
    ...mapState("certificado", ["jsonCertificado"]),
  },
  methods:{
    getInfoModal(arrayCertificado){
       const certificado = this.jsonCertificado.find(
          elem =>
            elem.idCertificado ==
            arrayCertificado.idCertificado
        ); 
      this.certificado.contenido = certificado.contenido;

      this.getCertificado(arrayCertificado.idCertificado);
    },
    getCertificado(idCertificado){
      this.axios
        .get('api/getCertificadoById/' + idCertificado)
        .then(res=>{
            this.certificado.urlHeader = res.data.certificado.urlHeader;
            this.certificado.urlFooter = res.data.certificado.urlFooter;
        })
    }
  }
}
</script>